import { getCurrentLangVoliaAPICode } from 'constants/languages';

export default function getLocalized(values = {}, fallback = '', translateFieldName) {
  const translatedValue = values[getCurrentLangVoliaAPICode()] || fallback;
  let result;

  if (typeof translatedValue === 'object') {
    if (translateFieldName) {
      result = translatedValue[translateFieldName];
    } else {
      result = translatedValue.title;
    }
  } else {
    result = translatedValue;
  }
  return result || fallback || '';
}
